(function() {
    'use strict';

    /*
    * A module for handling administrative workdrive related routes
    *
    */

    // Register all routes handled by this module
    angular
    .module('GorillaBoy.AdminWD')
    .config(['$routeProvider', function($routeProvider) {
        var TEMPLATE_LAYOUT = './assets/partials/app/layout.html';

        $routeProvider.when('/admin/workdrives', {
            auth: true,
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'AdminWDController'
        });
    }]);
}());